import {
  serializable,
  alias,
  object,
  primitive,
} from "serializr";

export class ReportCaseDetail {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("patient_id", primitive()))
  patientId?: string;
  
  @serializable(alias("patient_name", primitive()))
  patientName?: string;

  @serializable(alias("scan_type_id", primitive()))
  scanTypeId?: number;
  
  @serializable(alias("scan_type_name", primitive()))
  scanTypeName?: string;

  @serializable(alias("current_clinical_problem", primitive()))
  currentClinicalProblem?: string;
}

export class Assignment {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("string", primitive()))
  status?: string;

  @serializable(alias("case_detail", object(ReportCaseDetail)))
  caseDetail?: ReportCaseDetail;
}
